export function generatePseudoRandomNumber(length: number) {
	return Math.floor(Math.random() * 10 ** length);
}
